export const SET_SEARCH_EVENT_ID = "SET_SEARCH_EVENT_ID";
export const CLEAR_SEARCH_EVENT_ID = "CLEAR_SEARCH_EVENT_ID";
export const SET_PREVIOUS_PORTAL_URL = "SET_PREVIOUS_PORTAL_URL";
